/* eslint-disable no-console */
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

export default {
  install(Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl(`${Vue.prototype.$http.defaults.baseURL}/fantasy-hub`)
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build()

    let startedPromise = null

    function start() {
      startedPromise = connection
        .start()
        .then(() => {
          // eslint-disable-next-line no-console
          console.info('fantasy-hub connected')
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error('Failed to connect with hub', err)
          return new Promise((resolve, reject) =>
            setTimeout(
              () =>
                start()
                  .then(resolve)
                  .catch(reject),
              5000
            )
          )
        })

      return startedPromise
    }
    connection.onclose(() => start())

    // use new Vue instance as an event bus
    const importHub = new Vue()
    // every component will use this.$questionHub to access the event bus
    Vue.prototype.$importHub = importHub
    // Forward server side SignalR events through $questionHub, where components will listen to them
    connection.on('ImportStatus', message => {
      importHub.$emit('import-status', { message })
    })
    connection.on('ImportError', (message, errors) => {
      importHub.$emit('import-error', { message, errors })
    })
    connection.on('ImportCompleted', message => {
      importHub.$emit('import-completed', { message })
    })

    importHub.JoinActivityImportGroup = activityId => {
      return startedPromise
        .then(() => connection.invoke('JoinActivityImportGroup', activityId))
        .catch(console.error)
    }
    importHub.leaveActivityImportGroup = activityId => {
      return startedPromise
        .then(() => connection.invoke('LeaveActivityImportGroup', activityId))
        .catch(console.error)
    }

    start()
  }
}
